
<template>
  <div :class="'full-width ' + value.captionStyle">
    <div class="image-parent">
      <img :src="value.image.mobile || 'https://firebasestorage.googleapis.com/v0/b/mamamia-pwa.appspot.com/o/images%2FAMamamiasStory_Image-01.png129?alt=media&token=15b9cc5d-63c5-49e6-b253-d6a88cba0814'" />

      <div class="image-uploader">
        <button @click="changeImage" style="margin-left:10px;">CHANGE IMAGE</button>
      </div>

    </div>
    <input v-model="value.caption" class="caption" placeholder="Enter a caption..." />
    <input v-model="value.source" class="source" placeholder="Enter a source.." />
    <div class="selectHolder">
      <span>Caption Style</span>
      <select v-model="value.captionStyle">
        <option value="layout-1">Standard</option>
        <option value="layout-2">Over Image</option>
      </select>
    </div>

  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
require("firebase/firestore");

export default {
  components: { },
  data: function() {
    return {
      storage: firebase.storage()
    }
  },
  props:{
      value:{
          type: Object,
          required:true
      },
  },
  methods: {
    changeImage: function() {
      this.$emit('changeImage', {
        callback: (images) => {
          this.value.image = images
        }
      })
    },
    getFileName: function(file) {
      return file.name + Math.floor(Math.random() * 1000);
    }
  }
  
}
</script>
<style>
.image-uploader {
  position:absolute;
  left:0;
  top:0;
  bottom:0;
  right:0;
  background-color: rgba(0,0,0,0.6);
  justify-content:center;
  align-items: center;
  display:none;
}
.image-parent:hover .image-uploader {
  display:flex;
}
</style>
<style scoped>
.full-width {
  position:relative;
}
.layout-2 input.caption {
    background-color: rgba(0,0,0,0.3);
    border: 0;
    color: white;
    position: absolute;
    text-align: center;
    margin-top: -174px;
    font-size: 35px;
}
.layout-2 input.source {
  display:none;
}
img {
  height: 400px;
  width: 100%;
  object-fit: cover;
}
.image-parent {
  position:relative;
}

.selectHolder {
  width:300px;
  margin:5px auto;
  display:block
}
.selectHolder select {
  width:150px;
}
input {
  width:100%;
}

</style>


// WEBPACK FOOTER //
// imageFullWidth.vue?63548f64